// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1Hx0g","tabs":"style_tabs__1ypuc","item":"style_item__D26We","active":"style_active__3EBxD","box":"style_box__1NLF5"};